import type { Client } from '@zg-rentals/http-client';
import { CometUserAuthenticationWebHandler_getUser } from '@zg-rentals/ts-your-rental-api-client';
import { makeCometAuthProvider } from '@zg-rentals/auth-comet';
import { LoginMode, zillowWebLogin } from '@zillow/auth-core';
import { partialUrlEncode } from '@zg-rentals/auth-comet';

export const Auth = makeCometAuthProvider(({ client }: { client?: Client }) =>
  CometUserAuthenticationWebHandler_getUser({}, client),
);

export const { useAuth } = Auth;

export const redirectToLogin = (redirectUri: string) => {
  if (typeof window !== 'undefined') {
    const isDevelopment = process.env.NODE_ENV === 'development';

    zillowWebLogin({
      loginMode: LoginMode.REDIRECT,
      redirectUri: isDevelopment
        ? `/rental/your-rental-api/forward?protocol=https&port=3000&path=${partialUrlEncode(redirectUri)}`
        : redirectUri,
      trackingConfig: {
        entryPoint: 'your-rental-web',
      },
      envConfig: isDevelopment
        ? {
            baseURLOverride: process.env.NEXT_PUBLIC_PREFIX_URL,
          }
        : undefined,
    });
  }
};
